import html2pdf from 'html2pdf.js';
import React from 'react';
import BNBLOGO from "../assets/NavLogo/BNBLOGO.png"

class InvoicePDF {
  constructor() {
    this.options = {
      margin: 0.5,
      filename: 'invoice.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
    };
  }

  formatDate(dateString) {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }

  generateInvoiceHTML(orderData) {
    const { _id, products, totalAmount, shippingAddress, createdAt, status, user, chalan } = orderData;
    
    // Calculate subtotal, tax, and shipping
    let subtotal = 0;
    let totalTax = 0;
    let totalShipping = 0;
    
    products.forEach(item => {
      subtotal += item.price * item.quantity;
      totalTax += (item.gst || 0) * item.quantity + (item.extraTax || 0) * item.quantity;
      totalShipping += item.shippingCharge * item.quantity
    });

    const orderId = _id.slice(-8).toUpperCase();
    const invoiceDate = this.formatDate(createdAt);
    const chalanDate = chalan ? this.formatDate(chalan.generatedAt) : '';
    
    return `
      <!DOCTYPE html>
      <html>
      <head>
        <style>
          .invoice {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            max-width: 800px;
            margin: 0 auto;
            padding: 2rem;
            background: white;
            color: #333;
            box-shadow: 0 0 20px rgba(0,0,0,0.1);
          }
          
          .header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 2rem;
            padding-bottom: 1.5rem;
            border-bottom: 3px solid #4a6fdc;
          }
          
          .logo-container {
            display: flex;
            align-items: center;
          }
          
          .logo-img {
            height: 60px;
            width: auto;
          }
          
          .subtitle {
            color: #666;
            margin: 0.3rem 0 0;
            font-size: 0.9rem;
          }
          
          .invoice-title {
            color: #333;
            font-size: 1.8rem;
            margin: 0;
            text-align: right;
          }
          
          .section-title {
            color: #333;
            font-size: 1.2rem;
            margin: 0 0 0.8rem;
            padding-bottom: 0.5rem;
            border-bottom: 2px solid #4a6fdc;
          }
          
          .info-container {
            display: flex;
            justify-content: space-between;
            margin-bottom: 2rem;
            gap: 1.5rem;
          }
          
          .info-box {
            flex: 1;
          }
          
          .info-item {
            margin: 0.5rem 0;
            color: #555;
            font-size: 0.95rem;
          }
          
          .info-label {
            font-weight: 600;
            color: #444;
          }
          
          .items-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 1.5rem;
          }
          
          .items-table th {
            background-color: #f5f7fa;
            padding: 0.8rem;
            text-align: left;
            color: #444;
            font-weight: 600;
            border-bottom: 2px solid #ddd;
          }
          
          .items-table td {
            padding: 0.8rem;
            border-bottom: 1px solid #eee;
            color: #555;
            vertical-align: top;
          }
          
          .items-table tr:last-child td {
            border-bottom: none;
          }
          
          .text-right {
            text-align: right;
          }
          
          .text-center {
            text-align: center;
          }
          
          .summary-box {
            width: 300px;
            background-color: #f5f7fa;
            padding: 1.5rem;
            border-radius: 8px;
            margin-left: auto;
          }
          
          .summary-row {
            display: flex;
            justify-content: space-between;
            margin-bottom: 0.8rem;
          }
          
          .total-row {
            display: flex;
            justify-content: space-between;
            border-top: 2px solid #4a6fdc;
            padding-top: 1rem;
            margin-top: 1rem;
            font-weight: 600;
          }
          
          .total-amount {
            color: #4a6fdc;
            font-size: 1.2rem;
          }
          
          .footer {
            text-align: center;
            margin-top: 3rem;
            padding-top: 1.5rem;
            border-top: 1px solid #eee;
            color: #666;
          }
          
          .brand {
            font-weight: 600;
            color: #4a6fdc;
          }
          
          .product-name {
            font-weight: 600;
            margin-bottom: 0.3rem;
          }
          
          .product-detail {
            font-size: 0.85rem;
            color: #777;
            display: block;
          }

          .chalan-info {
            margin-top: 1.5rem;
            padding: 1rem;
            background-color: #f5f7fa;
            border-radius: 8px;
          }
        </style>
      </head>
      <body>
        <div class="invoice">
          <!-- Header -->
          <div class="header">
            <div class="logo-container">
              <img src="${BNBLOGO}" class="logo-img" alt="BNB Logo" />
            </div>
            <div>
              <h2 class="invoice-title">INVOICE</h2>
              <p class="subtitle">Date: ${invoiceDate}</p>
            </div>
          </div>

          <!-- Order Info -->
          <div class="info-container">
            <div class="info-box">
              <h3 class="section-title">Order Details</h3>
              <p class="info-item"><span class="info-label">Order ID:</span> #${orderId}</p>
              <p class="info-item"><span class="info-label">Status:</span> ${status}</p>
              <p class="info-item"><span class="info-label">Order Date:</span> ${invoiceDate}</p>
              ${chalan ? `
                <p class="info-item"><span class="info-label">Chalan Date:</span> ${chalanDate}</p>
                <p class="info-item"><span class="info-label">GST Number:</span> ${chalan.gstNumber}</p>
              ` : ''}
            </div>
            <div class="info-box">
              <h3 class="section-title">Customer Details</h3>
              <p class="info-item"><span class="info-label">Name:</span> ${user.firstName} ${user.lastName}</p>
              <p class="info-item"><span class="info-label">Email:</span> ${user.email}</p>
              <p class="info-item"><span class="info-label">Phone:</span> ${user.phone}</p>
            </div>
            <div class="info-box">
              <h3 class="section-title">Shipping Address</h3>
              <p class="info-item"><span class="info-label">${shippingAddress.fullName}</span></p>
              <p class="info-item">${shippingAddress.addressLine1}</p>
              ${shippingAddress.addressLine2 ? `<p class="info-item">${shippingAddress.addressLine2}</p>` : ''}
              <p class="info-item">${shippingAddress.city}, ${shippingAddress.state} ${shippingAddress.postalCode}</p>
              <p class="info-item">${shippingAddress.country}</p>
              <p class="info-item"><span class="info-label">Phone:</span> ${shippingAddress.phone}</p>
            </div>
          </div>

          ${chalan ? `
            <div class="chalan-info">
              <h3 class="section-title">Delivery Information</h3>
              <div class="info-container">
                <div class="info-box">
                  <p class="info-item"><span class="info-label">Vehicle Number:</span> ${chalan.vehicleNumber}</p>
                  <p class="info-item"><span class="info-label">Driver Name:</span> ${chalan.driverName}</p>
                </div>
                <div class="info-box">
                  <p class="info-item"><span class="info-label">Driver Phone:</span> ${chalan.driverPhone}</p>
                  <p class="info-item"><span class="info-label">License No.:</span> ${chalan.drivingLicense}</p>
                </div>
              </div>
            </div>
          ` : ''}

          <!-- Items Table -->
          <div>
            <h3 class="section-title">Order Items</h3>
            <table class="items-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th class="text-left">Brand</th>
                  <th class="text-left">Size</th>
                  <th class="text-left">Qty</th>
                  <th class="text-left">Price</th>
                  <th class="text-left">Total</th>
                </tr>
              </thead>
              <tbody>
                ${products.map(item => `
                  <tr>
                    <td>
                      <span class="product-name">${item?.product?.name}</span>
                      <span class="product-detail">${item?.product?.bb_id}</span>
                    </td>
                    <td class="text-left">${item?.product?.brand}</td>
                    <td class="text-left">${item.size}</td>
                    <td class="text-left">${item.quantity}</td>
                    <td class="text-left">₹${item.price.toFixed(2)}</td>
                    <td class="text-left">₹${(item.price * item.quantity).toFixed(2)}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>

          <!-- Summary -->
          <div class="summary-box">
            <h3 class="section-title">Order Summary</h3>
            <div class="summary-row">
              <span>Subtotal:</span>
              <span>₹${subtotal.toFixed(2)}</span>
            </div>
            <div class="summary-row">
              <span>Tax (GST):</span>
              <span>₹${totalTax.toFixed(2)}</span>
            </div>
            <div class="summary-row">
              <span>Shipping:</span>
              <span>₹${totalShipping.toFixed(2)}</span>
            </div>
            <div class="total-row">
              <span>Total Amount:</span>
              <span class="total-amount">₹${totalAmount.toFixed(2)}</span>
            </div>
          </div>

          <!-- Footer -->
          <div class="footer">
            <p>Thank you for your business!</p>
            <p>For any queries, please contact us at bricknbar1@gmail.com</p>
          </div>
        </div>
      </body>
      </html>
    `;
  }

  async generatePDF(orderData) {
    try {
      const htmlContent = this.generateInvoiceHTML(orderData);
      const orderId = orderData._id.slice(-8).toUpperCase();
      
      // Update filename with order ID
      this.options.filename = `invoice-${orderId}.pdf`;
      
      // Create a temporary element
      const element = document.createElement('div');
      element.innerHTML = htmlContent;
      
      // Generate PDF
      await html2pdf().set(this.options).from(element).save();
      
    } catch (error) {
      console.error('Error generating PDF:', error);
      throw error;
    }
  }
}

export default InvoicePDF;